import { render, staticRenderFns } from "./PieChart.vue?vue&type=template&id=b6e77cf2&"
import script from "./PieChart.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PieChart.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PieChart.vue?vue&type=style&index=0&id=b6e77cf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports